import { render } from "./HomeNewsDetailView.vue?vue&type=template&id=d5942636&scoped=true"
import script from "./HomeNewsDetailView.vue?vue&type=script&lang=js"
export * from "./HomeNewsDetailView.vue?vue&type=script&lang=js"

import "./HomeNewsDetailView.vue?vue&type=style&index=0&id=d5942636&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5942636"]])

export default __exports__